import {Component, Injector, ViewChild} from "@angular/core";
import {LoginService} from "../../../core/services/login.service";
import {Municipio} from "../../../../classes/municipio";
import {ActivatedRoute} from "@angular/router";
import {BaseComponent} from "../../../ui/components/base/base.component";
import {GlobalLoadingIndicator} from "../../../ui/decorators/global.loading.indicator.decorator";
import {LoginFilter} from "../../../core/filters/login.filter";
import {AlertService} from "../../../ui/services/alert.service";
import {ReCaptchaComponent} from "../../../ui/components/captcha/re.captcha.component";

@Component({
  selector: 'recupera-senha-page',
  templateUrl: './recupera.senha.page.component.html',
  styleUrls: ['./recupera.senha.page.component.scss']
})
export class RecuperaSenhaPageComponent extends BaseComponent {

  @ViewChild("reCaptchaComponent")
  reCaptchaComponent: ReCaptchaComponent;

  constructor(private activatedRoute: ActivatedRoute,
              private alertService: AlertService,
              private injector: Injector,
              private loginService: LoginService) {
    super(injector);
  }

  accordionUsuario: boolean = true;

  accordionSenha: boolean = false;

  bloqueiaCodigo: boolean = false;

  codigo: string = "";

  documento: string = "";

  municipio: Municipio;

  municipios: Municipio[] = [];

  senha: string = "";

  senhaConfirma: string = "";

  usuario: string = "";

  visibleUsuario: boolean = false;

  visibleSenha: boolean = false;

  reCaptchaResponse: string;

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(map => {
      this.usuario = map.get("usuario");
      this.codigo = map.get("codigo");

      this.visibleUsuario = true;

      if (this.usuario && this.codigo) {
        this.bloqueiaCodigo = true;
        this.visibleUsuario = false;
        this.visibleSenha = true;
      }
      this.carrega();
    });
  }

  protected doAfterViewInit() {
    if(this.reCaptchaComponent){
      this.reCaptchaComponent.init();
    }
  }

  @GlobalLoadingIndicator()
  acionaAlterar() {
    this.clearErrorMessages();

    if (!this.senha || !this.senhaConfirma) {
      this.addErrorMessage("Os campos senha e confirma senha são obrigatórios.");

      return;
    }

    if (this.senha.length < 6) {
      this.addErrorMessage("O campo senha deve possuir pelo menos seis caracteres.");

      return;
    }

    if (this.senha == this.senhaConfirma) {
      let loginFilter = new LoginFilter();
      loginFilter.senha = this.senha;
      loginFilter.usuario = this.usuario;
      loginFilter.sessionId = this.codigo;
      this.of(this.loginService.forgotPasswordSubmit(loginFilter), (resp: string) => {
        this.clearErrorMessages();

        if (!resp || resp == "SUCCESS") {
          this.alertService.show("A sua senha foi redefinida com sucesso.").then(() => this.navigate('/landing-page'));
        } else {
          this.addErrorMessage(resp);
        }
      })
    } else {
      this.addErrorMessage('A senha e sua confirmação deve ser iguais.');

      return;
    }
  }

  @GlobalLoadingIndicator()
  acionaEnviar() {
    this.clearErrorMessages();

    let reg = /[^LM\S{NP}]/g;

    if (!this.usuario || this.usuario.trim() == "") {
      this.addErrorMessage("O campo usuário é obrigatório.");

      return;
    }

    if (!this.documento || this.documento.trim() == "") {
      this.addErrorMessage("O campo CPF/CNPJ é obrigatório");

      return;
    }

    if (!this.reCaptchaResponse || this.reCaptchaResponse.trim() == "") {
      this.addErrorMessage("O campo CPF/CNPJ é obrigatório");

      return;
    }

    let loginFilter: LoginFilter = new LoginFilter();

    loginFilter.usuario = this.usuario;
    loginFilter.documento = this.documento;
    loginFilter.captcha = this.reCaptchaResponse;

    return this.of(this.loginService.recuperarSenha(loginFilter), () => {
          this.bloqueiaCodigo = false;
          this.codigo = "";
          this.accordionUsuario = false;
          this.visibleSenha = true;
          this.alertService.show("As instruções de recuperação foram enviadas para o e-mail cadastrado.").then(() =>{
            this.navigate('/landing-page');
          });
          this.reCaptchaComponent.reset();
    });

  }

  acionaVoltar() {
    this.clearErrorMessages();

    this.codigo = "";
    this.senha = "";
    this.usuario = "";
    this.accordionUsuario = true;

    this.visibleSenha = false;
    this.visibleUsuario = true;
  }

  alteraDocumento(evento: any) {
    if (evento) {
      this.documento = evento.replace(/\D/g, "");
    } else {
      this.documento = "";
    }
  }

  @GlobalLoadingIndicator()
  carrega() {
    return this.of(this.loginService.buscarListaMunicipioCliente(), municipios => this.municipios = municipios);
  }
}
